/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconOverflow = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M3.375 9.398a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25zM20.625 9.398a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25zM12 9.398a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25z" />
      </g>
    </svg>
  ),
);
